export default "__VITE_ASSET__CW2w2cvS__"